import {PlayerReduxState} from "../types";

export default function getLastUserInputResult(state: PlayerReduxState): PlayerReduxState["lastUserInputResult"] {
  return state.lastUserInputResult;
}
